import Vuex from 'vuex'
import Vue from 'vue'
import auth from './modules/auth'
import config from './modules/config'
import files from './modules/files/files'
import milestones from './modules/milestones'
import largeSidebar from './modules/largeSidebar'
import modals from './modules/modals/modals'
import team from './modules/teams'
import settings from './modules/settings'
import verticalSidebar from './modules/verticalSidebar'
import dashboard from './modules/dashboard'

// Load Vuex
Vue.use(Vuex)

// Create store
export default new Vuex.Store({
    modules: {
        auth,
        config,
        files,
        milestones,
        largeSidebar,
        modals,
        team,
        settings,
        verticalSidebar,
        dashboard,
    },
})
